<template>
  <div
    class="dropzone border border-dashed"
    @dragover="onDragover"
    @dragleave="onDragleave"
    @dragend="onDragged"
    @drop="onDropped">
    <div
      class="text-center mt-4 mb-4 d-flex justify-content-center ">
        <div v-if="!uploading">
          <ci-awesome-icon icon="cloud-upload" class="icon icon-muted" />
          <span class="text-muted ml-2">Datei(en) hier ziehen </span>
          <input
            v-if="type === 'single'"
            ref="fileInput"
            type="file"
            single
            :accept="accept"
            @change="fileSelected"
            hidden>

          <input
            v-if="type === 'multiple'"
            ref="fileInput"
            type="file"
            multiple
            :accept="accept"
            @change="fileSelected"
            hidden>
          <a
            href="#"
            @click="triggerUpload($event)">
            oder hier klicken
          </a>
        </div>
    </div>
  </div>
</template>

<script>
// components
import AwesomeIcon from '@/components/AwesomeIcon.vue';

export default {
  name: 'Dropzone',

  components: {
    'ci-awesome-icon': AwesomeIcon,
  },

  props: {
    accept: {
      type: String,
      required: false,
    },

    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },

    type: {
      type: String,
      required: false,
      default: 'single',
    },

    uploadType: {
      type: String,
      default: 'image',
    },
  },

  data() {
    return {
      uploading: false,
    };
  },

  methods: {
    addHoverClass() {
      const classes = this.$el.className.split(' ');
      if (classes.indexOf('dropzone-hover') === -1) {
        classes.push('dropzone-hover');
        this.$el.className = classes.join(' ');
      }
    },

    removeHoverClass() {
      const classes = this.$el.className.split(' ');
      if (classes.indexOf('dropzone-hover') !== -1) {
        const classIndex = classes.indexOf('dropzone-hover');
        classes.splice(classIndex, 1);
        this.$el.className = classes.join(' ');
      }
    },

    fileSelected() {
      const { files } = this.$refs.fileInput;
      this.filesSelected(files);
    },

    onDragleave() {
      this.removeHoverClass();
    },

    onDragover(evt) {
      evt.preventDefault();
      this.addHoverClass();
    },

    onDragged(evt) {
      evt.preventDefault();
      this.removeHoverClass();
    },

    onDropped(evt) {
      evt.preventDefault();
      const files = [];
      for (let i = 0; i < Object.keys(evt.dataTransfer.items).length; i += 1) {
        files.push(evt.dataTransfer.items[i].getAsFile());
      }
      this.filesSelected(files);
      this.removeHoverClass();
    },

    triggerUpload(evt) {
      evt.preventDefault();
      this.$refs.fileInput.click();
    },

    filesSelected(files) {
      this.$emit('dropzone:files-selected', files);
    },
  },
};
</script>
